import _ from '@lodash';
import XAPPService from "app/Core/services/XAPPService";
export const FORMPESSOA_INFO = '[FORMPESSOA APP] FORMPESSOA INFO';
export const FORMPESSOA_FUNCIONARIO_INFO = '[FORMPESSOA APP] FORMPESSOA FUNCIONARIO INFO';
export const FORMPESSOA_WARNING = '[FORMPESSOA APP] FORMPESSOA WARNING';
export const FORMPESSOA_ERROR = '[FORMPESSOA APP] FORMPESSOA ERROR';
export const GET_FORMPESSOA_TIPOS = '[FORMPESSOA APP] GET FORMPESSOA TIPOS';

const ChangeFuncionarioState = [
    'tipo',
    'uid'
];

export function changeFuncionario(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var obj = { tipo: "30", uid: _AValue.uid };
        if (!_.isUndefined(_AValue.tipo) && !_.isNull(_AValue.tipo) && _AValue.tipo > 0) {
            obj = { tipo: "31", uid: _AValue.uid };
        }

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "spdoactionregistro", "ATUALIZARFUNCIONARIO", obj, "", AConditionsAND, AConditionsOR, 1, ChangeFuncionarioState);

        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: FORMPESSOA_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: FORMPESSOA_FUNCIONARIO_INFO,
                            payload: response.info,
                            data: response.data
                        })
                    ])
                }
            }

            ).catch(error => {
                return dispatch({
                    type: FORMPESSOA_ERROR,
                    payload: error
                });
            });
    };
}

